
import { defineComponent, computed, PropType } from 'vue'

export default defineComponent({
  name: 'StarTemplateLockMask',
  props: {
    /** 三态锁：pending 骨架 / locked 解锁引导 / unlocked 展示内容 */
    lockState: {
      type: String as PropType<'pending' | 'locked' | 'unlocked'>,
      default: undefined
    },
    /** 兼容旧用法，等价于 lockState === 'locked' */
    locked: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '解锁后查看'
    },
    skeletonRows: {
      type: Number,
      default: 5
    },
    /** 锁定/加载态使用紧凑高度，避免空白区域过大 */
    compact: {
      type: Boolean,
      default: false
    }
  },
  emits: ['unlock'],
  setup(props) {
    const resolvedState = computed<'pending' | 'locked' | 'unlocked'>(() => {
      if (props.lockState) return props.lockState
      return props.locked ? 'locked' : 'unlocked'
    })
    return { resolvedState }
  }
})
